import { render, staticRenderFns } from "./CustomCarouselSkeleton.vue?vue&type=template&id=afaa2484"
import script from "./CustomCarouselSkeleton.vue?vue&type=script&lang=js"
export * from "./CustomCarouselSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CustomCarouselSkeleton.vue?vue&type=style&index=0&id=afaa2484&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports